// extracted by mini-css-extract-plugin
export default {"coverTheEachHere":"wallet_coverTheEachHere__XiaOa","absoluteDelete":"wallet_absoluteDelete__mEJPE","coverTheMap":"wallet_coverTheMap__l2Mqu"};